import axios from "axios";
import { ApiUrl } from "../../ApiUrl";

const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

export const getLatLongFromAddress = async (address: string) => {
  try {
    const res = await axios.get(
      `${ApiUrl.googleAPI.getGeoCode}?address=${address}&libraries=places&key=${API_KEY}`
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getTimeZone = async (latitude: number, longitude: number) => {
  try {
    const res = await axios.get(
      `${ApiUrl.googleAPI.getTimeZone}?location=${latitude}%2C${longitude}&timestamp=1331161200&key=${API_KEY}`
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};
